import GATSBY_COMPILED_MDX from "/home/runner/work/sigpwny.com/sigpwny.com/content/meetings/sp2022/2022-01-23/index.md";
import React, {useState} from "react";
import {MDXProvider} from "@mdx-js/react";
import {Document, Page} from 'react-pdf';
import Seo from "../components/Seo";
import {weekNumber, convertDate, getYouTubeEmbedUrl} from "../utils/util";
import {LeftSvg, PdfSvg, RightSvg, YouTubeSvg} from "../components/Icons";
export const Head = _ref => {
  var _meeting$image, _meeting$image$path$c, _meeting$image$path$c2;
  let {data} = _ref;
  const {meeting} = data;
  if (!meeting) {
    throw new Error("invalid argument: \"meeting\" is undefined");
  }
  return React.createElement(Seo, {
    title: meeting.title,
    description: meeting.semester + " Week " + weekNumber(meeting.week_number) + " • " + convertDate(meeting.time_start, "MMMM DD, YYYY", meeting.timezone),
    image: (_meeting$image = meeting.image) !== null && _meeting$image !== void 0 && _meeting$image.path ? (_meeting$image$path$c = meeting.image.path.childImageSharp) === null || _meeting$image$path$c === void 0 ? void 0 : (_meeting$image$path$c2 = _meeting$image$path$c.gatsbyImageData.images.fallback) === null || _meeting$image$path$c2 === void 0 ? void 0 : _meeting$image$path$c2.src : undefined,
    video: meeting.recording ? getYouTubeEmbedUrl(meeting.recording) : undefined,
    type: "article"
  });
};
const MeetingTemplate = _ref2 => {
  var _meeting$slides, _meeting$slides2;
  let {data, children} = _ref2;
  const {meeting} = data;
  if (!meeting) {
    throw new Error("invalid argument: \"meeting\" is undefined");
  }
  const {0: numPages, 1: setNumPages} = useState(1);
  const {0: pageNumber, 1: setPageNumber} = useState(1);
  return React.createElement(React.Fragment, null, React.createElement("article", {
    className: "panel w-full grow",
    itemScope: true,
    itemType: "http://schema.org/Article"
  }, React.createElement("header", null, React.createElement("p", {
    className: "font-mono m-0"
  }, meeting.semester, " Week ", weekNumber(meeting.week_number), " \u2022 ", React.createElement("time", null, convertDate(meeting.time_start, "MMMM DD, YYYY", meeting.timezone))), React.createElement("h1", {
    className: "mb-1",
    itemProp: "headline"
  }, meeting.title), React.createElement("p", null, "Presented by:\xA0", React.createElement("span", {
    rel: "author",
    itemProp: "author"
  }, meeting.credit.length > 0 ? meeting.credit.join(', ') : "SIGPwny"))), React.createElement("div", {
    className: "grid sm:flex sm:flex-row gap-2 mb-4"
  }, meeting.recording ? React.createElement("a", {
    href: meeting.recording,
    className: "btn-primary",
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(YouTubeSvg, null), React.createElement("p", {
    className: "inline align-middle m-0 ml-2"
  }, "Watch video")) : null, (_meeting$slides = meeting.slides) !== null && _meeting$slides !== void 0 && _meeting$slides.publicURL ? React.createElement("a", {
    href: meeting.slides.publicURL,
    className: "btn-primary"
  }, React.createElement(PdfSvg, null), React.createElement("p", {
    className: "inline align-middle m-0 ml-2"
  }, "Download slides")) : null), meeting.recording && (() => {
    const url = getYouTubeEmbedUrl(meeting.recording);
    return url ? React.createElement("iframe", {
      title: meeting.title + " video",
      className: "bg-surface-000 w-full max-w-2xl aspect-video mx-auto mb-4",
      allow: "encrypted-media; fullscreen; picture-in-picture",
      allowFullScreen: true,
      src: url,
      itemProp: "video"
    }) : null;
  })(), ((_meeting$slides2 = meeting.slides) === null || _meeting$slides2 === void 0 ? void 0 : _meeting$slides2.publicURL) && !meeting.recording && React.createElement("div", {
    className: "flex flex-col items-center"
  }, React.createElement(Document, {
    className: "flex flex-col",
    file: meeting.slides.publicURL,
    onLoadError: console.error,
    onLoadSuccess: _ref3 => {
      let {numPages} = _ref3;
      return setNumPages(numPages);
    }
  }, React.createElement(Page, {
    className: "m-1",
    pageNumber: pageNumber
  })), React.createElement("div", null, React.createElement("button", {
    title: "Previous slide",
    className: "mx-2 " + (pageNumber <= 1 ? "text-secondary" : "text-primary hover:text-secondary"),
    disabled: pageNumber <= 1,
    onClick: () => setPageNumber(pageNumber - 1)
  }, React.createElement(LeftSvg, null)), pageNumber || (numPages ? 1 : '--'), " of ", numPages || '--', React.createElement("button", {
    title: "Next slide",
    className: "mx-2 " + (pageNumber >= numPages ? "text-secondary" : "text-primary hover:text-secondary"),
    disabled: pageNumber >= numPages,
    onClick: () => setPageNumber(pageNumber + 1)
  }, React.createElement(RightSvg, null)))), React.createElement(MDXProvider, null, React.createElement("section", {
    className: "md-root w-full max-w-prose mx-auto",
    itemProp: "articleBody"
  }, children))));
};
MeetingTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(MeetingTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
const query = "1363295201";
